import "core-js/stable";
import "regenerator-runtime/runtime";
import React from "react";
import ReactDOM from "react-dom";
import IBuyerConnectLeadCapture from "../components/IBuyerConnectLeadCapture";

document.addEventListener("DOMContentLoaded", () => {
  ReactDOM.render(
    <IBuyerConnectLeadCapture />,
    document.getElementById("ibuyer-connect-lead-capture-form")
  );
});
